<div *ngIf="load" [id]="id" class="custom-modal row px-0 mx-0" [ngStyle]="{'z-index': zIndex}" [ngClass]="{ 'd-none': !visible, 'd-block': visible }">
  <div class= "row h-100 w-100 px-0 mx-0 justify-content-center" [ngClass]="{ 'align-items-center': top === 'center' }">
    <div class="custom-modal-content {{getcols().xs}} {{getcols().sm}} {{getcols().md}} {{getcols().ls}} {{getcols().xl}} px-0 mx-0" #content
    [style.margin-top]="top"
    [style.overflow]="'none'"
    [ngStyle]="{
      maxWidth: width === 'auto' ? '95%' : '',
      maxHeight: height === 'auto' ? '95%' : height,
      height : height !== 'auto' ? height : 'auto'
    }">
      <div class="custom-modal-close position-absolute" (click)="close()">
          <i class="fas fa-times"></i>
      </div>
      <ng-content class="h-100 w-100"></ng-content>
    </div>
  </div>
</div>



